// lib
import React from 'react';

// def
interface IconCrossProps {
  iconWidth?: number;
  className?: string;
}

function Cross({ iconWidth = 24, className = '' }: IconCrossProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={iconWidth}
      height={iconWidth}
      fill="none"
      viewBox="0 0 24 25"
    >
      <path
        fill="#000"
        d="M20.31 4.177a.999.999 0 00-1.42 0l-6.89 6.9-6.89-6.9a1.004 1.004 0 10-1.42 1.42l6.9 6.89-6.9 6.89a1 1 0 000 1.42.998.998 0 001.42 0l6.89-6.9 6.89 6.9a.998.998 0 001.42 0 .997.997 0 00.219-1.094.998.998 0 00-.22-.326l-6.9-6.89 6.9-6.89a.998.998 0 000-1.42z"
      />
    </svg>
  );
}

export default Cross;
